import { Constant } from "./layout.constant";

class CanvasListDraw {
    static drawListBorder(element, pagerow, convertPointUnit, drawline) {
        const dcunit = {
            ax1: convertPointUnit(element.ax1),
            ax2: convertPointUnit(element.ax2),
            ay1: convertPointUnit(element.ay1),
            ay2: convertPointUnit(element.ay2),
        };
        const dcrowheight = convertPointUnit(element.rowHeight)
        const dctitleheight = convertPointUnit(element.titleHeight)
        const dcfooterHeight = convertPointUnit(element.footerHeight)

        const dclistwidth = dcunit.ax2 - dcunit.ax1
        const dclistheight = dcunit.ay2 - dcunit.ay1


        //计算行数等
        let capacitHeight = (element.ay2 - element.ay1)
        if (element.title) {
            capacitHeight -= element.titleHeight
        }
        if (element.footer) {
            capacitHeight -= element.footerHeight
        }
        const capacityrows = parseInt(capacitHeight / element.rowHeight)

        let rows = 0
        if (element.rowfill) {
            rows = capacityrows
        } else {
            rows = Math.min(capacityrows, pagerow.length)
        }


        let offsetYtemp = 0
        //表头
        if (element.title && dclistheight - offsetYtemp >= dctitleheight) {
            //顶线
            drawline(element.titleTop, dcunit.ax1, dcunit.ay1, dcunit.ax2, dcunit.ay1, element.weight, element.borderColor)
            //左侧
            drawline(element.titleLeft, dcunit.ax1, dcunit.ay1 + offsetYtemp, dcunit.ax1, dcunit.ay1 + offsetYtemp + dctitleheight, element.weight, element.borderColor)
            //右侧
            drawline(element.titleRight, dcunit.ax2, dcunit.ay1 + offsetYtemp, dcunit.ax2, dcunit.ay1 + offsetYtemp + dctitleheight, element.weight, element.borderColor)


            let offsetXtemp = 0
            for (let index = 0; index < element.cols.length - 1; index++) {
                const col = element.cols[index];
                const dcwidth = convertPointUnit(col.width)
                if (dcunit.ax1 + offsetXtemp + dcwidth < dcunit.ax2) {
                    drawline(element.titleInside, dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1, dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + dctitleheight, element.weight, element.borderColor)
                    offsetXtemp += dcwidth
                } else {
                    break;
                }
            }


            if (element.titleBottom && !element.rowTop) {
                drawline(element.titleBottom, dcunit.ax1, dcunit.ay1 + offsetYtemp + dctitleheight, dcunit.ax2, dcunit.ay1 + offsetYtemp + dctitleheight, element.weight, element.borderColor)
            }
            offsetYtemp += dctitleheight
        }

        //表体
        for (let index = 0; index < rows; index++) {
            if (index == 0) {
                //顶部线
                drawline(element.rowTop, dcunit.ax1, dcunit.ay1 + offsetYtemp, dcunit.ax2, dcunit.ay1 + offsetYtemp, element.weight, element.borderColor)
            }

            if (index == rows - 1) {
                //底部
                drawline(element.rowBottom, dcunit.ax1, dcunit.ay1 + offsetYtemp + dcrowheight, dcunit.ax2, dcunit.ay1 + offsetYtemp + dcrowheight, element.weight, element.borderColor)
            } else {
                //中间
                drawline(element.rowInsideH, dcunit.ax1, dcunit.ay1 + offsetYtemp + dcrowheight, dcunit.ax2, dcunit.ay1 + offsetYtemp + dcrowheight, element.weight, element.borderColor)
            }
            //左侧
            drawline(element.rowLeft, dcunit.ax1, dcunit.ay1 + offsetYtemp, dcunit.ax1, dcunit.ay1 + offsetYtemp + dcrowheight, element.weight, element.borderColor)
            //右侧
            drawline(element.rowRight, dcunit.ax2, dcunit.ay1 + offsetYtemp, dcunit.ax2, dcunit.ay1 + offsetYtemp + dcrowheight, element.weight, element.borderColor)

            //中间垂直线
            let offsetXtemp = 0
            for (let index = 0; index < element.cols.length - 1; index++) {
                const col = element.cols[index];
                const dcwidth = convertPointUnit(col.width)
                if (dcunit.ax1 + offsetXtemp + dcwidth <= dcunit.ax2) {
                    drawline(element.rowInsideV, dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp, dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp + dcrowheight, element.weight, element.borderColor)

                }
                offsetXtemp += dcwidth
            }
            offsetYtemp += dcrowheight
        }

        //表尾
        if (element.footer && dclistheight - offsetYtemp >= dcfooterHeight) {
            //顶部
            if (element.footerTop && !element.rowBottom) {
                drawline(element.footerTop, dcunit.ax1, dcunit.ay1 + offsetYtemp, dcunit.ax2, dcunit.ay1 + offsetYtemp, element.weight, element.borderColor)
            }
            //左侧
            drawline(element.footerLeft, dcunit.ax1, dcunit.ay1 + offsetYtemp, dcunit.ax1, dcunit.ay1 + offsetYtemp + dcfooterHeight, element.weight, element.borderColor)
            //右侧
            drawline(element.footerRight, dcunit.ax2, dcunit.ay1 + offsetYtemp, dcunit.ax2, dcunit.ay1 + offsetYtemp + dcfooterHeight, element.weight, element.borderColor)
            //底部
            drawline(element.footerBottom, dcunit.ax1, dcunit.ay1 + offsetYtemp + dcfooterHeight, dcunit.ax2, dcunit.ay1 + offsetYtemp + dcfooterHeight, element.weight, element.borderColor)

            //表尾的内部线
            let offsetXtemp = 0
            let colspantemp = 0
            let colwidthtemp = 0
            for (let index = 0; index < element.cols.length - 1; index++) {
                const col = element.cols[index];
                const dcwidth = convertPointUnit(col.width)
                const colspan = col.footerColspan
                if (colspantemp - 1 > 0) {
                    colwidthtemp += dcwidth
                    colspantemp--;
                } else if (colspantemp == 1) {
                    colwidthtemp += dcwidth
                    if (dcunit.ax1 + offsetXtemp + colwidthtemp < dcunit.ax2) {
                        drawline(element.footerInside, dcunit.ax1 + offsetXtemp + colwidthtemp, dcunit.ay1 + offsetYtemp, dcunit.ax1 + offsetXtemp + colwidthtemp, dcunit.ay1 + offsetYtemp + dcfooterHeight, element.weight, element.borderColor)
                    }
                    offsetXtemp += colwidthtemp
                    colspantemp = 0
                    colwidthtemp = 0
                } else {
                    if (colspan > 1) {
                        colwidthtemp = dcwidth
                        colspantemp = colspan - 1;
                    } else {
                        let colofx = 0
                        if (dcunit.ax1 + offsetXtemp + dcwidth < dcunit.ax2) {
                            drawline(element.footerInside, dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp, dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ay1 + offsetYtemp + dcfooterHeight, element.weight, element.borderColor)

                        }
                        offsetXtemp += dcwidth
                    }
                }
            }
            offsetYtemp += dcfooterHeight
        }
        return rows
    }

    static drawListContent(element, pagerow, convertPointUnit, drawText, drawImage, drawBarCode, drawQrCode) {
        const dcunit = {
            ax1: convertPointUnit(element.ax1),
            ax2: convertPointUnit(element.ax2),
            ay1: convertPointUnit(element.ay1),
            ay2: convertPointUnit(element.ay2),
        };
        const dctitleheight = convertPointUnit(element.titleHeight)
        const dcrowheight = convertPointUnit(element.rowHeight)
        const dcfooterHeight = convertPointUnit(element.footerHeight)
        const dclistwidth = dcunit.ax2 - dcunit.ax1
        const dclistheight = dcunit.ay2 - dcunit.ay1

        

        //绘制表头
        let offsetYtemp = 0
        if (element.title && dctitleheight + offsetYtemp <= dclistheight) {
            let offsetXtemp = 0
            for (let index = 0; index < element.cols.length; index++) {
                if (offsetXtemp >= dclistwidth) {
                    break;
                }
                const col = element.cols[index];
                let dcwidth = convertPointUnit(col.width)
                if (index == element.cols.length - 1) {
                    dcwidth = dclistwidth - offsetXtemp
                }
                const rect = {
                    ax1: dcunit.ax1 + offsetXtemp + col.padding,
                    ay1: dcunit.ay1 + offsetYtemp + col.padding,
                    ax2: Math.min(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ax2) - col.padding,
                    ay2: dcunit.ay1 + offsetYtemp + dctitleheight - col.padding
                }
                rect.ax = rect.ax1
                rect.ay = rect.ay1
                rect.width = rect.ax2 - rect.ax1
                rect.height = rect.ay2 - rect.ay1
                drawText(col, col.title, rect)
                offsetXtemp += dcwidth
            }
            offsetYtemp += dctitleheight
        }

        //绘制表体
        for (let rowindex = 0; rowindex < element.pageRowCount; rowindex++) {
            if (rowindex < pagerow.length) {
                let offsetXtemp = 0
                for (let index = 0; index < element.cols.length; index++) {
                    if (offsetXtemp >= dclistwidth) {
                        break;
                    }
                    const col = element.cols[index];
                    let dcwidth = convertPointUnit(col.width)
                    if (index == element.cols.length - 1) {
                        dcwidth = dclistwidth - offsetXtemp
                    }
                    const rect = {
                        ax1: dcunit.ax1 + offsetXtemp + col.padding,
                        ay1: dcunit.ay1 + offsetYtemp + col.padding,
                        ax2: Math.min(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ax2) - col.padding,
                        ay2: dcunit.ay1 + offsetYtemp + dcrowheight - col.padding
                    }
                    rect.ax = rect.ax1
                    rect.ay = rect.ay1
                    rect.width = rect.ax2 - rect.ax1
                    rect.height = rect.ay2 - rect.ay1
                    if (col.display == Constant.LIST_COL_DISPLAY_IMAGE) {
                        drawImage(pagerow[rowindex][col.field], rect)
                    } else if (col.display == Constant.LIST_COL_DISPLAY_BARCODE) {
                        drawBarCode(pagerow[rowindex][col.field], rect)
                    } else if (col.display == Constant.LIST_COL_DISPLAY_QRCODE) {
                        drawQrCode(pagerow[rowindex][col.field], rect)
                    } else {
                        drawText(col, pagerow[rowindex][col.field], rect)
                    }
                    offsetXtemp += dcwidth
                }
            }
            offsetYtemp += dcrowheight
        }

        //绘制表尾
        if (element.footer && dcfooterHeight + offsetYtemp <= dclistheight) {
            let offsetXtemp = 0 //单元格起点偏移
            let colspantemp = 0 //单元格跨列计算剩余
            let colwidthtemp = 0 //单元格跨列计算当前宽度
            let colelement = undefined
            for (let index = 0; index < element.cols.length; index++) {
                if (offsetXtemp >= dclistwidth) {
                    break;
                }
                const col = element.cols[index];
                let dcwidth = convertPointUnit(col.width)
                if (index == element.cols.length - 1) {
                    dcwidth = dclistwidth - (offsetXtemp + colwidthtemp)
                }
                const colspan = Math.max(parseInt(col.footerColspan), 1)


                if (colspantemp - 1 > 0) {
                    colwidthtemp += dcwidth
                    colspantemp--;
                } else if (colspantemp == 1) {
                    colwidthtemp += dcwidth
                    const rect = {
                        ax1: dcunit.ax1 + offsetXtemp + col.padding,
                        ay1: dcunit.ay1 + offsetYtemp + col.padding,
                        ax2: Math.min(dcunit.ax1 + offsetXtemp + colwidthtemp, dcunit.ax2) - col.padding,
                        ay2: dcunit.ay1 + offsetYtemp + dctitleheight - col.padding
                    }
                    rect.ax = rect.ax1
                    rect.ay = rect.ay1
                    rect.width = rect.ax2 - rect.ax1
                    rect.height = rect.ay2 - rect.ay1
                    drawText(colelement, colelement.footerText, rect)
                    offsetXtemp += colwidthtemp

                    colspantemp = 0
                    colwidthtemp = 0
                    colelement = undefined
                } else {
                    if (colspan > 1) {
                        colwidthtemp = dcwidth
                        colspantemp = colspan - 1;
                        colelement = col
                    } else {
                        const rect = {
                            ax1: dcunit.ax1 + offsetXtemp + col.padding,
                            ay1: dcunit.ay1 + offsetYtemp + col.padding,
                            ax2: Math.min(dcunit.ax1 + offsetXtemp + dcwidth, dcunit.ax2) - col.padding,
                            ay2: dcunit.ay1 + offsetYtemp + dctitleheight - col.padding
                        }
                        rect.ax = rect.ax1
                        rect.ay = rect.ay1
                        rect.width = rect.ax2 - rect.ax1
                        rect.height = rect.ay2 - rect.ay1
                        drawText(col, col.footerText, rect)
                        offsetXtemp += dcwidth
                    }
                }
            }
        }
    }
}

export {
    CanvasListDraw
}